/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bad_Muddy_Florian_SparkInputs */

const en_bad_muddy_florian_spark = /** @type {(inputs: Bad_Muddy_Florian_SparkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger`)
};

/**
* | output |
* | --- |
* | "Trigger" |
*
* @param {Bad_Muddy_Florian_SparkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bad_muddy_florian_spark = /** @type {((inputs?: Bad_Muddy_Florian_SparkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bad_Muddy_Florian_SparkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bad_muddy_florian_spark(inputs)
});